import { connect } from 'react-redux'
import IntegracionPantallas from '../IntegracionPantallas.jsx';

import
{
    cargaInicialPantalla,
    mostrarOcultarModal
} from '../../actions/Actions.js';

const mapStateToProps = (state) => {
  return {
      data: {
        ...state.integracionPantallas.data,
        ruta: JSON.parse(localStorage.portico).menuProductos.menuUsuario.find(producto => producto.codigo == "MAXWELL")
                                             .categorias.find(categoria => categoria.codigo == "TableroDescriptivos")
                                             .programas.find(programa => programa.codigo == "CONSUMOS").ruta,
        login: JSON.parse(localStorage.portico).sesion.executionContext.login
      }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    cargaInicialPantalla: (login) => {
        dispatch(cargaInicialPantalla(login));
    },
    mostrarOcultarModal: (valor) => {
      dispatch(mostrarOcultarModal(valor));
    }
  }
}

const TDConsumosContainer = connect(mapStateToProps, mapDispatchToProps)(IntegracionPantallas);

export default TDConsumosContainer;
